module.exports = __webpack_public_path__ + "static/CloudComputing-1d8613f463cbbdf997c05ba59f4d49f2.jpg";